import React from 'react';

import { ACTION_CONST, APY_NOTICE_CONTENT } from '../constants';

const NotiFyAPYModal = (props) => {


    return (
        <div className="modal fade " id="doubleAPYNotify" tabIndex="-1" aria-labelledby="doubleAPYNotifyLabel">
            <div className="modal-dialog modal-md modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="NotiFyAPYModalLabel"> <i className="fas fa-info-circle"></i>&nbsp;Double APY:</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">

                        {APY_NOTICE_CONTENT}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary"  data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default NotiFyAPYModal;


